import { Link } from "react-router-dom";
import { MonoButton } from "../kits";
import { useState, useRef } from "react";
import RoughBorder from "../kits/LayoutKit/RoughBorder";

export default function BlogCard({ post }) {
  const placeholder = "/images/b_gray-full.svg";
  const [isLoaded, setIsLoaded] = useState(false);
  const cardRef = useRef();

  return (
    <Link
      ref={cardRef}
      to={`/post/${post.slug}`}
      className="relative shadow-lg h-full flex flex-col justify-between rounded-2xl p-4 hover:shadow-sm transition-all  
        bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7]"
      // ⚠️ KEIN Tailwind `border` mehr!
    >
      {/* Textbereich */}
      <div className="flex flex-col justify-start gap-1 flex-grow min-h-[120px]">
        <h2 className="text-xs text-left text-amber-100 bg-gray-950 rounded-md pt-2 pb-2 pl-2 tracking-tight line-clamp-2 h-[50px]">
          {post.title}
        </h2>
        <p className="text-xs text-left text-gray-600 line-clamp-2 mt-5 px-2 h-[40px]">
          {post.subtitle}
        </p>
      </div>

      {/* Bild */}
      <div className="relative w-full h-40 overflow-hidden rounded-lg mb-4">
        <img
          src={post.image || placeholder}
          alt={post.title || "Blogbild"}
          loading="lazy"
          onLoad={() => setIsLoaded(true)}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = placeholder;
          }}
          className={`object-cover w-full h-full transition-all duration-500 bg-amber-50 pt-2 pb-2 pl-2 pr-2 rounded-md border border-gray-800 shadow-lg ${
            isLoaded ? "backdrop-blur-sm scale-100" : "blur-md scale-105"
          }`}
        />
      </div>

      {/* Button */}
      <div className="mt-4">
        <MonoButton className="w-full text-xs"
        
        underlineColors="ZenAmber"
        textColor="text-amber-100"
        >
          
          Mehr lesen
          
          </MonoButton>
      </div>

      {/* RoughBorder außen */}
      <RoughBorder
        parentRef={cardRef}
        radius={10}
        padding={2}
       color="#AC8E66" 
        strokeWidth={0.3}
        roughness={1}
        bowing={1.5}
      />
    </Link>
  );
}
